import Vue from 'vue'
import App from './App.vue'
import router from './router'
import '@/assets/styles/index.scss' // global css
import '@/assets/styles/check.css'
import '@/assets/styles/content.css'
import '@/assets/styles/chunk-vendors.5a58ee0d.css'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import VueCookies from 'vue-cookies';
import store from './store'
Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.use(VueCookies);

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')


